var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-expansion-panels',[_c('v-expansion-panel',[_c('v-expansion-panel-header-ex',{attrs:{"label":"ペルソナ"}}),_c('v-expansion-panel-content',[_c('persona-info')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }